<div style="padding: 10px;">
    <button (click)="openModal()"
            *ngIf="isPermissionConfirmed"
            class='{{finance? "btn btn-block btn-primary finance" : "btn btn-primary" }} gbo_shadow'
            data-action="openCreateContractModal">
        <span>{{ 'CONTRACTS.BUTTONS.CREATE' | translate }}</span>
    </button>
</div>

<ng-template #createContractView
             let-modal>
    <app-button-modal-close (closeEmit)="description = ''"
                            [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.CONTRACT' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #contractName
               aria-describedby="emailHelp"
               class="form-control"
               required>

        <h2 class="mt-3">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h2>
        <div class="task__content mb-3">
            <app-component-ckeditor
                    (emitFinish)="description = $event[1]"
                    [isShowButtons]="false">
            </app-component-ckeditor>
        </div>

        <button (click)="createContracts(contractName, modal)"
                [disabled]="isLockButton"
                class="btn btn-success"
                data-action="createContract"
                style="margin-top: 10px;">
            <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.CREATE' | translate }}</span>
        </button>
    </div>
</ng-template>
<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>
